<template>
  <div data-v-249f9abc="" class="wrapper clearfix">
    <div data-v-1dc60391="" data-v-249f9abc="" class="content clearfix">
      <div data-v-1dc60391="" class="main">
        <div data-v-064cc9e2="" data-v-1dc60391="" >
          <h1 data-v-064cc9e2="">
            增值税专票申请
          </h1>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="150px"
            class="demo-ruleForm"
          >
          <el-form-item label="营业执照：" prop="zjzm_qi" class="cl_one">
                  <el-upload
                    action="https://jsonplaceholder.typicode.com/posts/"
                    list-type="picture-card"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog :visible.sync="dialogVisible">
                    <img width="100%" :src="dialogImageUrl" alt="" />
                  </el-dialog>
                </el-form-item>
                <el-form-item label="开户许可证：" prop="zjfm_qi" class="jiakuan">
                  <el-upload
                    action="https://jsonplaceholder.typicode.com/posts/"
                    list-type="picture-card"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog :visible.sync="dialogVisible">
                    <img width="100%" :src="dialogImageUrl" alt="" />
                  </el-dialog>
                </el-form-item>
                <el-form-item label="法人代表复印件：" prop="frontOfIDCard" class="cl_one">
                  <el-upload
                    action="https://jsonplaceholder.typicode.com/posts/"
                    list-type="picture-card"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog :visible.sync="dialogVisible">
                    <img width="100%" :src="dialogImageUrl" alt="" />
                  </el-dialog>
                </el-form-item>
                <el-form-item label="经办人复印件：" prop="frontOfIDCard_jb" class="cl_one">
                  <el-upload
                    action="https://jsonplaceholder.typicode.com/posts/"
                    list-type="picture-card"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog :visible.sync="dialogVisible">
                    <img width="100%" :src="dialogImageUrl" alt="" />
                  </el-dialog>
                </el-form-item>
                <el-form-item label="联系人：" prop="jingbani_qi">
                  <el-input
                    v-model="ruleForm.jingbani_qi"
                    class="jianwidth"
                    placeholder="请输入联系人"
                  ></el-input>
                </el-form-item>
                <el-form-item label="联系电话：" prop="jblxfs_qi">
                  <el-input
                    v-model="ruleForm.jblxfs_qi"
                    class="jianwidth"
                    placeholder="请输入联系电话"
                  ></el-input>
                </el-form-item>
                <el-form-item label="户号：" prop="accountNo">
                  <el-input
                    v-model="ruleForm.accountNo"
                    class="jianwidth"
                    placeholder="请输入户号"
                  ></el-input>
                </el-form-item>
                <el-form-item label="地址：" prop="address">
                  <el-input
                    v-model="ruleForm.address"
                    class="jianwidth"
                    placeholder="请输入地址"
                  ></el-input>
                </el-form-item>
                <el-form-item style="margin-bottom: 50px;">
                  <el-button type="primary" :plain="true" @click="submitForm('ruleForm')">提交</el-button>
                </el-form-item>
                <!-- <el-form-item style="">
                  <el-butto type="primary" :plain="true" @click="submitForm('ruleForm')">提交</el-butto>
                </el-form-item> -->
          </el-form>

          <!-- <h2 style="display: flex"><span>办理流程</span></h2>
                    <div style="height: 400px;padding-left: 16px">
                        <el-steps direction="vertical" :active="1">
                            <el-step title="在线下载相关资料，填写基本信息">
                              <span slot="description" style="margin-top: 20px" >
                                  <span style="color: #8F8F8F;font-size: 13px">请备妥以下相关证明材料</span><br/>
                                  <span style="color: #596167;font-size: 15px;margin-top: 16px">1、给排水管线改迁图纸（2套）和电子版光盘</span><br/>
                                  <span style="color: #8F8F8F;font-size: 13px;padding-left: 26px;margin-top: 5px">需准备两套改迁图纸</span><br>
                                  <span style="color: #596167;font-size: 15px;margin-top: 16px;width: 400px;display: flex;justify-content: space-between">
                                      <div>2、<span style="color: #409EFF">《管线改迁申请表》</span></div>
                                           <el-button type="primary" style="height: 28px;line-height: 2px;width: 100px">下载</el-button>
                                  </span>
                                  <span style="color: #8F8F8F;font-size: 13px;padding-left: 26px;margin-bottom: 20px">由建设单位填写并加盖公章</span><br>
                              </span>
                            </el-step>
                            <el-step title="工作人员上门服务" description="受理之日起2个工作日内约定上门，收集资料、查看现场"></el-step>
                            <el-step title="出具迁改意见" description="经查看现场，符合迁改条件的7个工作日内出具"></el-step>
                            <el-step title="办理完毕"></el-step>
                        </el-steps>
                    </div> -->
        </div>
      </div>
      <businessAside />
    </div>
  </div>
</template>

<script>
import businessAside from "../../components/aside";
export default {
  data() {
    return {
      fileList: "",
      textarea: "",
      ruleForm: {
        name: "",
        num: "",
        dizhi: "",
        region1: "",
        region3: "",
        zjzm_qi: "",
        zjfm_qi: "",
        frontOfIDCard: "",
        frontOfIDCard_jb: "",
        jingbani_qi: "",
        jblxfs_qi: "",
        address: "",
        accountNo: "",
      },
      rules: {
        // zjzm_qi: [
        //   {
        //     required: true,
        //     message: "请上传原单位营业执照",
        //     trigger: "change",
        //   },
        // ],
        // zjfm_qi: [
        //   {
        //     required: true,
        //     message: "请上传现单位营业执照",
        //     trigger: "change",
        //   },
        // ],
        jingbani_qi: [
          { required: true, message: "请输入联系人", trigger: "blur" },
          { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        jblxfs_qi: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          { min: 11, max: 11, message: "11位字符", trigger: "blur" },
        ],
        // frontOfIDCard_jb: [
        //     { required: true, message: '请上传身份证有人像的一面', trigger: 'change' }
        // ],
        // frontOfIDCard: [
        //     { required: true, message: '请上传身份证有人像的一面', trigger: 'change' }
        // ],
        backOfIDCard: [
          { required: true, message: '请上传身份证有国徽的一面', trigger: 'change' }
        ],
        accountNo: [
          { required: true, message: "请输入户号", trigger: "change" },
        ],
        address: [
          { required: true, message: "请输入地址", trigger: "change" },
        ],
        name: [
          { required: true, message: "请输入用户姓名", trigger: "blur" },
          { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        num: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { min: 11, max: 11, message: "11位字符", trigger: "blur" },
        ],
        
        region1: [
          { required: true, message: "请选择问题类型", trigger: "change" },
        ],
        
        region3: [
          { required: true, message: "请选择所在区域", trigger: "change" },
        ],
        dizhi: [
          { required: true, message: "请输入身份证号", trigger: "change" },
        ],
        
      },
      // ruleForm: {
      //     name: '',
      //     region: '',
      //     yanzh:''
      // },
      // rules: {
      //     name: [
      //         { required: true, message: '请输入10位客户编号', trigger: 'blur' },
      //         { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
      //     ],
      //     region: [
      //         { required: true, message: '请选择活动区域', trigger: 'change' }
      //     ],
      // }
    };
  },
  watch: {
    // subType(n) {
    //     if ([0, 1, 2].indexOf(n) !== -1) {
    //         this.disabled = false
    //     } else {
    //         this.disabled = true
    //     }
    //     console.log(this.disabled)
    // },
    // isOk(n) {
    //     if (n) {
    //         this.disabled = false
    //     } else {
    //         this.disabled = true
    //     }
    //     console.log(this.disabled)
    // },
  },
  methods: {
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-3);
    },
    submitForm() {
      this.$message({
          message: '提交成功,请勿重复此操作!',
          type: 'success'
        });
    },
    // submitForm(formName) {
    //     this.$refs[formName].validate((valid) => {
    //         if (valid) {
    //             alert('submit!');
    //         } else {
    //             console.log('error submit!!');
    //             return false;
    //         }
    //     });
    // },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // toRegret() {
    //     const BASE_PATH = window.location.href.split('#')[0]
    //     window.location.href = BASE_PATH + '#' + '/regret_pe'
    // },
  },
  components: {
    businessAside,
  },
};
</script>

<style scoped>
span {
  display: inline-block;
}
h2 {
  color: #8f8f8f;
  padding: 20px;
}
</style>
